import { render, staticRenderFns } from "./PageDayCare.vue?vue&type=template&id=4f265420&scoped=true&"
import script from "./PageDayCare.vue?vue&type=script&lang=js&"
export * from "./PageDayCare.vue?vue&type=script&lang=js&"
import style0 from "./PageDayCare.vue?vue&type=style&index=0&id=4f265420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f265420",
  null
  
)

export default component.exports